var _circle, _circle2, _rect, _path, _path2, _path3, _path4, _path5, _path6, _circle3, _circle4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCatBody(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 38,
    fill: "#e8faf0",
    stroke: "#a0e0c0",
    strokeWidth: 2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 24,
    r: 10,
    fill: "#f5c8a0",
    stroke: "#d4956a",
    strokeWidth: 1.5
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 35,
    width: 20,
    height: 18,
    rx: 4,
    fill: "#f5c8a0",
    stroke: "#d4956a",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40 40 Q40 37 43 37 Q46 37 46 40 Q46 43 40 46 Q34 43 34 40 Q34 37 37 37 Q40 37 40 40Z",
    fill: "#e84080",
    opacity: 0.85
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30 38 Q22 40 20 48",
    stroke: "#d4956a",
    strokeWidth: 4,
    strokeLinecap: "round",
    fill: "none"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M50 38 Q58 40 60 48",
    stroke: "#d4956a",
    strokeWidth: 4,
    strokeLinecap: "round",
    fill: "none"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M34 53 L32 68",
    stroke: "#d4956a",
    strokeWidth: 5,
    strokeLinecap: "round",
    fill: "none"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M46 53 L48 68",
    stroke: "#d4956a",
    strokeWidth: 5,
    strokeLinecap: "round",
    fill: "none"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M36 25 Q40 28 44 25",
    stroke: "#5a3825",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    fill: "none"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 37,
    cy: 22,
    r: 1.5,
    fill: "#3a2a1a"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 43,
    cy: 22,
    r: 1.5,
    fill: "#3a2a1a"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCatBody);
export default __webpack_public_path__ + "static/media/cat-body.b7e100d159fce43b1ce3ba13dde22ee1.svg";
export { ForwardRef as ReactComponent };